import { VscCircleFilled } from "react-icons/vsc";
import "../../style/mobile/azmoon-list/M_Exam.scss";
import icon1 from "../../../assets/mobile/azmoon-list/vuesax-linear-teacher.svg";
import icon2 from "../../../assets/mobile/azmoon-list/vuesax-linear-timer.svg";
import { useState } from "react";
import q_img1 from "../../../assets/azmoon-list/exam/amanda-jones-oHVdj31R3F4-unsplash.jpg";
import { useSelector } from "react-redux";

let choice_badge_list = ["الف", "ب", "ج", "د"];

const M_Exam = ({ ID }) => {
  const [data_list] = useState([
    {
      id: 1,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 1,
          choice: "3",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 1,
          choice: "5",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 1,
          choice: "9",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 1,
          choice: "10",
          isSelected: false,
        },
      ],
    },
    {
      id: 2,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 2,
          choice: "امکان دارد شاید و یا یک چیز دیگر",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 2,
          choice: "امکان دارد گزینه اول درست باشد",
          isSelected: false,
        },
      ],
    },
    {
      id: 3,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 3,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 3,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 3,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 3,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 4,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 4,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 4,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 4,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 4,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 5,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 5,
          choice: "الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 5,
          choice: "ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 5,
          choice: "ج",
          isSelected: false,
        },
      ],
    },
    {
      id: 6,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 6,
          choice: "سال 2010",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 6,
          choice: "سال 2015",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 6,
          choice: "سال 2017",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 6,
          choice: "سال 2020",
          isSelected: false,
        },
      ],
    },
    {
      id: 7,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 7,
          choice: "امکان دارد شاید و یا یک چیز دیگر",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 7,
          choice: "امکان دارد گزینه اول درست باشد",
          isSelected: false,
        },
      ],
    },
    {
      id: 8,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 8,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 8,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 8,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 8,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 9,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 9,
          choice: "من نظری ندارم",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 9,
          choice: "سوال مبهم است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 9,
          choice: "جواب تقریبی است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 9,
          choice: "جواب قطعی است",
          isSelected: false,
        },
      ],
    },
    {
      id: 10,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 10,
          choice:
            "این متنی آزمایشی برای تست این کد است و معنای دیگری ندارد و ادامه ای این متن نیز برای طولانی کردن پاسخ است و هدف دیگری ندارد",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 10,
          choice: "این متنی آزمایشی برای تست این کد و معنای دیگری ندارد",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 10,
          choice: "این متنی آزمایشی برای تست این کد و معنای دیگری ندارد",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 10,
          choice: "این متنی آزمایشی برای تست این کد و معنای دیگری ندارد",
          isSelected: false,
        },
      ],
    },
    {
      id: 11,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 11,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 11,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 11,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 11,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 12,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 12,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 12,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 12,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 12,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 13,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 13,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 13,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 13,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 13,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 14,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 14,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 14,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 14,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 14,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 15,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 15,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 15,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 15,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 15,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 16,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 16,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 16,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 16,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 16,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 17,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: "",
    },
    {
      id: 18,
      isActive: false,
      question: "",
      question_img: q_img1,
      choices: [
        {
          id: 1,
          sub_id: 18,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 18,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 18,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 18,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
  ]);

  const state = useSelector((state) => state.default);
  let data;
  for (let i = 0; i < state.ExamData.length; i++) {
    if (state.ExamData[i].id === Number(ID)) {
      data = state.ExamData[i];
    }
  }



  //--answer list-------------------------------------------
  let answer_list = [];
  for (let i = 0; i < data_list.length; i++) {
    answer_list.push(0);
  }
  // console.log(answer_list);
  //--choice-index-list-------------------------------------
  let choice_index_counter = 0;
  let choice_index_list = [];
  for (let i = 0; i < data_list.length; i++) {
    choice_index_list.push(choice_index_counter);
    for (let j = 0; j < data_list[i].choices.length; j++) {
      choice_index_counter++;
    }
  }
  // console.log(choice_index_list);
  //--choose a choice setting--and movment-----------------------------------------------------
  let visible_circles_number = Math.floor(window.innerWidth / 66.975);
  const chooseChoice = (id, sub_id, index) => {
    const choices = document.querySelectorAll(
      ".M-Exam-main-item-choices-item-text"
    );
    const badge_choices = document.querySelectorAll(
      ".M-Exam-main-item-choices-item-badge"
    );
    const progress_bar_circles = document.querySelectorAll(
      ".M-Exam-progress-bar-item-circle"
    );
    if (index + 1 > visible_circles_number) {
      //movment --------------------------
      let movement = (index + 1 - visible_circles_number) * 66.975;
      document.querySelector(".M-Exam-progress-bar").scrollLeft = -movement;
    } else {
      document.querySelector(".M-Exam-progress-bar").scrollLeft = 0;
    }
    //------------------------------------------------------------------------

    if (answer_list[sub_id - 1] !== 0) {
      choices[
        choice_index_list[sub_id - 1] + answer_list[sub_id - 1] - 1
      ].style.backgroundColor = "#F5F5F5";
      choices[
        choice_index_list[sub_id - 1] + answer_list[sub_id - 1] - 1
      ].style.color = "#132F52";

      badge_choices[
        choice_index_list[sub_id - 1] + answer_list[sub_id - 1] - 1
      ].style.backgroundColor = "#E7E7E7";
      badge_choices[
        choice_index_list[sub_id - 1] + answer_list[sub_id - 1] - 1
      ].style.color = "#132F52";
    }
    if (answer_list[sub_id - 1] === id) {
      progress_bar_circles[sub_id - 1].style.backgroundColor = "#F5F5F5";
      progress_bar_circles[sub_id - 1].style.color = "#A2B4CB";
      answer_list[sub_id - 1] = 0;
      // console.log(answer_list);
    } else {
      choices[choice_index_list[sub_id - 1] + id - 1].style.backgroundColor =
        "#74DF2C";
      choices[choice_index_list[sub_id - 1] + id - 1].style.color = "#FFF";
      progress_bar_circles[sub_id - 1].style.backgroundColor = "#74DF2C";
      progress_bar_circles[sub_id - 1].style.color = "#FFF";

      badge_choices[
        choice_index_list[sub_id - 1] + id - 1
      ].style.backgroundColor = "#63C81F";
      badge_choices[choice_index_list[sub_id - 1] + id - 1].style.color =
        "#FFF";
      answer_list[sub_id - 1] = id;
      // console.log(answer_list);
    }
  };
  //------------------------------------------------------------
  const updateProgressBar = (e, id) => {
    let progress = document.querySelectorAll(
      ".M-Exam-progress-bar-item-circle"
    );
    // console.log(e);
    if (e.target.value.length > 0) {
      progress[id - 1].style.backgroundColor = "#74DF2C";
      progress[id - 1].style.color = "#fff";
    } else {
      progress[id - 1].style.backgroundColor = "#F5F5F5";
      progress[id - 1].style.color = "#A2B4CB";
    }
  };
  //progress bar movement ---------------------------------------
  const moverProgressBar = (index) => {
    if (index + 1 > visible_circles_number) {
      let movement = (index + 1 - visible_circles_number) * 66.975;
      document.querySelector(".M-Exam-progress-bar").scrollLeft = -movement;
    } else {
      document.querySelector(".M-Exam-progress-bar").scrollLeft = 0;
    }
  };
  return (
    <div className="M-Exam">
      <div className="M-Exam-top-cover"></div>
      <div className="M-Exam-info">
        <div className="M-Exam-info-row1">
          <div className="M-Exam-info-row1-title-and-subtitle-box">
            <div className="M-Exam-info-row1-title-box">
              <img src={icon1} alt="title-icon" />
              <div className="M-Exam-info-row1-title-box-text">
                {data.name}
              </div>
            </div>
            <div className="M-Exam-info-row1-subtitle-box">
              <VscCircleFilled className="M-Exam-info-row1-subtitle-box-icon" />
              <div className="M-Exam-info-row1-subtitle-box-text">
                {data.text}
              </div>
            </div>
          </div>
          <div className="M-Exam-info-row1-time">
            <VscCircleFilled className="M-Exam-info-row1-time-icon" />
            <div className="M-Exam-info-row1-time-text">
              ساعت <span>14:41</span>
            </div>
          </div>
        </div>
        <div className="M-Exam-info-row2">
          <img src={icon2} alt="clock icon" />
          <div className="M-Exam-info-row2-text">زمان باقیمانده :</div>
          <div className="M-Exam-info-row2-timer">48:29</div>
        </div>
      </div>
      <div className="M-Exam-progress-bar">
        {data_list.map((item, index) => (
          <div key={item.id} className="M-Exam-progress-bar-item">
            <div className="M-Exam-progress-bar-item-circle">{index + 1}</div>
            <div className="M-Exam-progress-bar-item-line">------</div>
          </div>
        ))}
      </div>
      <div className="M-Exam-main">
        {data_list.map((item, index1) => (
          <div id={`${item.id}`} key={item.id} className="M-Exam-main-item">
            <div className="M-Exam-main-item-number">سوال {index1 + 1}</div>
            {item.question && (
              <div className="M-Exam-main-item-question">{item.question}</div>
            )}
            {!item.question && (
              <div className="M-Exam-main-item-question-img">
                <img src={item.question_img} alt="تصویر سوال امتحانی" />
              </div>
            )}
            <div className="M-Exam-main-item-choices">
              {item.choices &&
                item.choices.map((item, index) => (
                  <div
                    key={item.id}
                    className="M-Exam-main-item-choices-item"
                    onClick={() => chooseChoice(item.id, item.sub_id, index1)}
                  >
                    <div className="M-Exam-main-item-choices-item-badge">
                      {choice_badge_list[index]}
                    </div>
                    <div className="M-Exam-main-item-choices-item-text">
                      {item.choice}
                    </div>
                  </div>
                ))}
            </div>
            {!item.choices && (
              <div className="M-Exam-main-item-answer-box">
                <div className="M-Exam-main-item-answer-box-badge">
                  تشریح پاسخ
                </div>
                <textarea
                  name="answer-box"
                  id=""
                  cols="30"
                  rows="10"
                  className="M-Exam-main-item-answer-box-input"
                  placeholder="لطفا پاسخ خود را در این قسمت تایپ کنید و از امکانات شگرف این سامانه لذت ببرید"
                  onBlur={(e) => updateProgressBar(e, item.id)}
                  onFocus={() => moverProgressBar(index1)}
                ></textarea>
              </div>
            )}
            <div className="M-Exam-main-item-line"></div>
          </div>
        ))}
        <div className="M-Exam-main-btn-container">
          <div className="M-Exam-main-btn-container-line"></div>
          <div className="M-Exam-main-btn-container-btn">
            ذخیره اطلاعات و پایان آزمون
          </div>
          <div className="M-Exam-main-btn-container-line"></div>
        </div>
      </div>
    </div>
  );
};

export default M_Exam;
